import { useId, useSyncExternalStore } from "react";

let source: string | null = null;
const listeners = new Set<() => void>();

const setSource = (next: string | null) => {
    if (source === next) {
        return;
    }
    source = next;
    listeners.forEach((listener) => listener());
};

const subscribe = (listener: () => void) => {
    listeners.add(listener);
    return () => listeners.delete(listener);
};

export const artworkMorphName = (podcastId: number) => `podcast-art-${podcastId}`;

/** Forget the artwork that was tapped; call once the navigation it started has been rendered. */
export const clearArtworkMorph = () => setSource(null);

/**
 * Lets a podcast's artwork morph into the podcast page header on navigation. A podcast can appear
 * several times on one page and view transition names must be unique, so only the instance that was
 * tapped gets a name: call `markSource` from its click handler and put `name` on its ArtworkMorph.
 */
export const useArtworkMorphSource = (podcastId: number) => {
    const instance = useId();
    const isSource = useSyncExternalStore(subscribe, () => source) === instance;

    return {
        name: isSource ? artworkMorphName(podcastId) : undefined,
        markSource: () => setSource(instance),
    };
};
